import { DropdownIndicator } from 'components/form/DropdownIndicator';
import SelectDataField from 'components/v2/form/select-data-field/SelectDataField';
import { useTranslation } from 'react-i18next';
import { RegionModel } from 'services/EpdClient';
import styled from 'styled-components';
import { StyledReactSelect } from 'styles/Styles.styled';
import { Option } from 'types/types';

interface Prop {
  name: string;
  countryId: string | null;
  regions: RegionModel[];
  /** Legacy react-select styles; when omitted, renders using the shared SelectDataField design. */
  styles?: any;
  label: string;
  enableTooltipError?: boolean | undefined;
  supressErrors?: boolean | undefined;
  isDisabled?: boolean | undefined;
}

const AvailableCountryRegions: React.FC<Prop> = ({
  name,
  regions,
  styles,
  label,
  countryId,
  enableTooltipError,
  supressErrors,
  isDisabled,
}) => {
  const { t } = useTranslation();

  const availableRegionOptions: Option[] = countryId
    ? regions
        .filter((region) => region.countryId === countryId)
        .map((region) => ({ value: region.id ?? '', label: region.name } as Option))
    : [];

  if (availableRegionOptions.length === 0) {
    return null;
  }

  if (!styles) {
    return (
      <SelectDataField
        label={label}
        placeholder={t('placeholder.select')}
        name={name}
        required
        isMulti={false}
        disabled={isDisabled}
        options={availableRegionOptions}
        shouldShowBottomError={(err) => err !== t('messages.required')}
      />
    );
  }

  const availableCountryRegions: Option[] = [{ value: '', label: '' }].concat(availableRegionOptions);

  return (
    <Grid>
      <StyledReactSelect
        placeholder={t('placeholder.select')}
        required={true}
        label={label}
        name={name}
        styles={styles}
        options={availableCountryRegions}
        enableTooltipError={enableTooltipError}
        supressErrors={supressErrors}
        components={{ DropdownIndicator }}
        isDisabled={isDisabled}
      />
    </Grid>
  );
};

const Grid = styled.div`
  display: grid;

  ${StyledReactSelect} {
    margin: 0.5rem 0 1rem;
  }

  label {
    ${(props) => props.theme.fonts.textSmall}
  }
`;

export default AvailableCountryRegions;
